import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './component/main/main.component';
import { JobSearchComponent } from './component/job-search/job-search.component';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { JobsModule } from '../jobs/jobs.module';
import { HomeResolver } from './resolvers/home-resolver';

const routes: Routes = [
  { path: "home", component: MainComponent, resolve: { latestJobs: HomeResolver } }
];


@NgModule({
  declarations: [MainComponent, JobSearchComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    SharedModule,
    JobsModule
  ]
})
export class HomeModule { }
